import React, { useState, useEffect } from 'react';
import Input from '../../atoms/Input/Input';
import Button from '../../atoms/Button/Button';
import useRequest from "../../../context/useRequest";
import ConfirmationModal from "../../atoms/ConfirmationModal/ConfirmationModal";
import FormCountryCodes from "./FormCountryCodes";

const ContactForm = () => {

    const { data: isContactData, sendRequest } = useRequest();
    const [isFormData, setIsFormData] = useState({
        first_name: '',
        last_name:'',
        email: '',
        country_code:'',
        phone: '',
        message: '',
    });
    useEffect(() => {
            if (isContactData && Object.keys(isContactData).length > 0) {
                setIsFormData((prev) => {
                    return JSON.stringify(prev) === JSON.stringify(isContactData) ? prev : { ...prev, ...isContactData };
                });
            }
        }, [isContactData]);
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [showModal, setShowModal] = useState(false);

    const contactHandlar = (e) => {
        const { name, value } = e.target;
       
        if (name === "phone" && !/^\d*$/.test(value)) {

            return;
        }
        if (name === "last_name" | name === "first_name" && !/^[A-Za-z]*$/.test(value)) {

            return;
        }
        // console.log(`Updated ${name}: ${value}`);
        setIsFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };
    const submitHandlar = async (e) => {
        e.preventDefault();
        const formContact = new FormData();
        formContact.append("first_name", isFormData.first_name);
        formContact.append("last_name", isFormData.last_name);
        formContact.append("email", isFormData.email);
        formContact.append("country_code", isFormData.country_code);
        formContact.append("phone", isFormData.phone);
        formContact.append("message", isFormData.message);

        try {
            const response = await sendRequest({
                method: "POST",
                url: "/contactUs",
                body: formContact,
            });

            if (response) {
                setShowModal(true);
                
            } else {
                console.log("Condition failed. Response or data is missing.");
            }
        } catch (error) {
            // console.error("Error response:", error.response);
            if (error.response?.data?.errors) {
                setIsFieldErrors(error.response.data.errors);
            } else {
                alert("An unexpected error occurred.");
            }
        }

    }
    const handleCloseModal = (e) => {
        // console.log('Modal closing and resetting form');
        setShowModal(false);
        setIsFormData({
            first_name: '',
            last_name: '',
            email: '',
            country_code: '',
            phone: '',
            message: '',
        });
        // setTimeout(() => {
        //     console.log('Form data after reset:', isFormData);  
        // }, 0);
    };
    return (
        <>

            <form className='contact-section-form' onSubmit={submitHandlar}>
                <div className='login-form--item-left-form-row'>
                
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="first_name"
                            placeholder="Full Name"
                            value={isFormData.first_name}
                            onChange={contactHandlar}
                            className="form-control"
                            label={
                                <span>
                                    Full Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                            required
                        />
                        {isFieldErrors.first_name && (
                            <p className="error-message">{isFieldErrors.first_name}</p>
                        )}
                    </div>
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={isFormData.last_name}
                            onChange={contactHandlar}
                            className="form-control"
                            pattern="^[A-Za-z]+$"
                            label={
                                <span>
                                    Last Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.last_name && (
                            <p className="error-message">{isFieldErrors.last_name}</p>
                        )}
                    </div>
                </div>
                    <div className='input-group contact-section-form-row-input w-100' >
                        <Input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={isFormData.email}
                            onChange={contactHandlar}
                            label={
                                <span>
                                    Email <span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.email && (
                            <p className="error-message">{isFieldErrors.email}</p>
                        )}
                    </div>
                
                <div className="login-form--item-left-form-row ">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <FormCountryCodes
                            value={isFormData.country_code}
                            onChange={contactHandlar}
                        />
                        {isFieldErrors.country_code && (
                            <p className="error-message">{isFieldErrors.country_code}</p>
                        )}
                    </div>

                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="phone"
                            placeholder="Phone No"
                            value={isFormData.phone}
                            onChange={contactHandlar}
                            className="form-control"
                            pattern="^[0-9]*$"
                            minLength="8"
                            maxLength="14"
                            label={
                                <span>
                                    Phone No<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.phone && (
                            <p className="error-message">{isFieldErrors.phone}</p>
                        )}
                    </div>
                </div>
                
                <div className='input-group contact-section-form-input' >
                
                    <textarea
                        name="message"
                        placeholder="Message"
                        value={isFormData.message}
                        onChange={contactHandlar}
                        className="form-control"
                        label={
                            <span>
                                Message <span style={{ color: "red" }}>*</span>
                            </span>
                        }
                    />
                    {isFieldErrors.message && (
                            <p className="error-message">{isFieldErrors.message}</p>
                        )}
                        
                </div>

                <div className='input-group submitButton mb-0' >

                    <Button
                        type="submit"
                        label='Submit'
                        className="submit"


                    />
                </div>
            </form>
            <ConfirmationModal
                show={showModal}
                onClose={handleCloseModal}
                title="Form Submitted Successfully"
                body="Our customer executive will reach out to you shortly."
                className="modalshow"
                actions={[
                    {
                        label: "Submit",
                        onClick: handleCloseModal,
                        className: "btn-custom",
                    },
                ]}
            />
        </>
    )
}
export default ContactForm